import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../context/auth';
import simulatedsService from '../../../../services/simulateds.service';

function PendingSimulatedAction() {
    const auth = useContext(AuthContext);
    const naviget = useNavigate();
    const [isLoadingPending, setIsLoadingPending] = useState(true);
    const [isLoadingNewSimulated, setIsLoadingNewSimulated] = useState(false);
    const [pendingSimulated, setPendingSimulated] = useState(null);

    useEffect(() => {
        const loadPendingSimulated = async () => {
            let response = await simulatedsService.pending();

            if (response.status === 'success') {
                setPendingSimulated(response.data);
                setIsLoadingPending(false);
            }

            if (response.status === 'error') {
                if (response.error === 'invalid token') {
                    auth.setIsLoggedIn(false);
                }

                setIsLoadingPending(false);
            }
        };

        loadPendingSimulated();
    }, [auth]);

    const newSimulated = async () => {
        setIsLoadingNewSimulated(true);

        let response = await simulatedsService.new();
        const simulatedId = Number(response?.idSimulated ?? 0);

        if (response.status === 'success' && simulatedId > 0) {
            naviget(`/simulado/${simulatedId}`);
            return;
        }

        if (response.status === 'error') {
            if (response.error === 'invalid token') {
                auth.setIsLoggedIn(false);
            }

            if (response.error === 'User already has a pending simulated') {
                const pendingResponse = await simulatedsService.pending();

                if (pendingResponse.status === 'success' && pendingResponse.data?.id) {
                    naviget(`/simulado/${pendingResponse.data.id}`);
                    return;
                }
            }

            setIsLoadingNewSimulated(false);
            return;
        }

        setIsLoadingNewSimulated(false);
        console.error('Unable to create simulated', response);
    };

    if (isLoadingPending) {
        return (
            <Button
                className="mt-5 mb-5 d-flex gap-1 align-items-center"
                disabled
                type="button"
                variant="primary"
            >
                <span className="spinner-border spinner-border-sm me-3"></span>
                <span>Aguarde</span>
            </Button>
        );
    }

    if (pendingSimulated) {
        return (
            <Button
                as={Link}
                className="mt-5 mb-5 d-inline-flex gap-1 align-items-center"
                to={`/simulado/${pendingSimulated.id}`}
                type="button"
                variant="primary"
            >
                <span>Continuar simulado</span>
                <span>
                    <svg width="20px" height="20px" viewBox="0 0 16 16">
                        <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" fill="#FFFFFF" />
                    </svg>
                </span>
            </Button>
        );
    }

    return (
        <Button
            className="mt-5 mb-5 d-flex gap-1 align-items-center"
            disabled={isLoadingNewSimulated}
            onClick={newSimulated}
            type="button"
            variant="primary"
        >
            {
                isLoadingNewSimulated ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-3"></span>
                        <span>Aguarde</span>
                    </>
                ) : (
                    <>
                        <span>
                            <svg height="30px" width="30px" viewBox="0 0 16 16">
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" fill="#FFFFFF" />
                            </svg>
                        </span>
                        <span>Iniciar simulado</span>
                    </>
                )
            }
        </Button>
    );
}

export default PendingSimulatedAction;
